<div class="content" data-testid="common-ag-grid-content">
  <div class="sub-content" data-testid="sub-content">
    <!-- Error display -->
    @if (hasError()) {
    <div class="error-message">
      <img class="error-icon" src="/images/notification2.svg" alt="error" />
      <div class="error-message-text">
        <p>
          {{
            'PROTOCOL_GROUP.MESSAGES.VALIDATION_ERROR_MESSAGE_TEXT1' | translate
          }}
        </p>
        <span>
          {{
            'PROTOCOL_GROUP.MESSAGES.VALIDATION_ERROR_MESSAGE_TEXT2' | translate
          }}</span
        >
      </div>
    </div>
    } @else if (hasWarning()) {
    <div class="warning-message" data-testid="ag-grid-warning-message">
      <img class="warning-icon" src="/images/warning.svg" alt="warning" />
      <div class="warning-message-text">
        <p>
          {{ 'GENERAL.CAUTION' | translate }}
        </p>
        <span>{{ warningMessage() }}</span>
      </div>
    </div>
    }

    <!-- Grid icons -->
    <div
      class="grid-icons"
      data-testid="grid-icons"
      [ngClass]="{ 'width-100': !hasError() && !hasWarning() }"
    >
      <!-- Delete -->
      @if (showDeleteIcon()) {
      <lib-icon-button
        [disabled]="!(isRowSelected() && deleteEnabled())"
        [imgActive]="isRowSelected() && deleteEnabled()"
        activeImgSrc="images/delete-active.svg"
        inactiveImgSrc="images/trash-bin.svg"
        altText="Delete"
        [tooltipText]="'GENERAL.DELETE' | translate"
        [tooltipDisabled]="!(isRowSelected() && deleteEnabled())"
        (actionClick)="onDeleteIconClick()"
      >
      </lib-icon-button>
      }
      <!-- Download/Export -->
      @if (showDownloadIcon()) {
      <lib-icon-button
        [disabled]="!isRowSelected()"
        [imgActive]="isRowSelected() && downloadEnabled()"
        activeImgSrc="images/download.svg"
        inactiveImgSrc="images/download-disabled.svg"
        altText="Download"
        [tooltipText]="'GENERAL.DOWNLOAD' | translate"
        [tooltipDisabled]="!isRowSelected() && downloadEnabled()"
        (actionClick)="onExport()"
      >
      </lib-icon-button>
      }
      <!-- Import -->
      @if (showUploadIcon()) {
      <lib-icon-button
        activeImgSrc="images/upload.svg"
        inactiveImgSrc="images/upload.svg"
        altText="Upload"
      >
      </lib-icon-button>
      }
      <!-- Edit Columns -->
      @if (showColumnSettingsIcon()) {
      <button
        #columnsBtn
        id="gear-icon"
        class="icon-button"
        (click)="openPopup()"
      >
        <img
          [src]="settingsIconSrc()"
          alt="Settings"
          [matTooltip]="'PROTOCOL_GROUP.EDIT_COLUMNS' | translate"
          matTooltipPosition="above"
          matTooltipClass="ag-grid-custom-tooltip"
          class="grid-icon"
        />
      </button>
      }
      <!-- Create button -->
      @if (showCreateButton() && buttonLabel()) {
      <lib-button
        (click)="onCreateButtonClicked()"
        [color]="color()"
        [icon]="createButtonIcon()"
        [disabled]="!createEnabled()"
        [disabledBgColor]="'var(--disabled)'"
        [disabledTextColor]="'var(--white)'"
        class="add-button"
        >{{ buttonLabel() }}</lib-button
      >
      }
    </div>
  </div>

  <!-- AG Grid content -->
  <ag-grid-angular
    #agGrid
    data-testid="common-ag-grid"
    [class.scrolled-to-right]="isScrolledToRight()"
    [columnDefs]="colDefs()"
    (gridReady)="onGridReady($event)"
    [sideBar]="sideBar"
    [defaultColDef]="defaultColDef()"
    [gridOptions]="gridOptions()"
    [theme]="theme"
    [pinnedTopRowData]="pinnedTopRowData()"
    [popupParent]="getPopupParent()"
    [loading]="isLoadingTable()"
    (selectionChanged)="onSelectionChanged()"
    (cellValueChanged)="cellValueChanged.emit($event)"
  />
</div>

<!-- Custom Column Filter Popup -->
<lib-app-columns-popup
  #overlay
  [anchor]="columnsBtn()?.nativeElement"
  [canReset]="canResetGrid()"
  [isDirty]="isGridDirty()"
  (resetColumns)="resetAllColumns()"
  (save)="onSaveColumns()"
/>
